import React, { useState } from "react";
import styles from "./PostInstallPage.module.css";
import logo from "../../assets//revyz-logo-svg.png";
import Button from "@atlaskit/button";
import { API } from "../../utility/Api";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import { useNavigate } from "react-router-dom";
import { UseToast } from "../../components/context/ToastContext";
import { errorHandler } from "../../helpers/helpers";
import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";
import ArchiveIcon from "@atlaskit/icon/glyph/archive";
import RecentIcon from "@atlaskit/icon/glyph/recent";
import LocationIcon from "@atlaskit/icon/glyph/location";
import ProjectExclusion from "../ProjectExclusion/ProjectExclusion";
const PostInstallPage = ({
  setDisplayPostInstall,
  setWelcomePage,
  prevPath,
}) => {
  const [next, setNext] = useState(false);
  const [projectPage, setProjectPage] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();
  const setMainMessage = UseToast();

  const handleFinish = (excludedProjects, includedProjects) => {
    const pauseBackup = async (token) => {
      await API.put(
        "api/pause-scheduled-backup?install=1",
        { pauseScheduledBackup: false },
        {
          headers: {
            Authorization: `JWT ${token}`,
          },
        }
      )
        .then(function (response) {})
        .catch(function (error) {
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
          setDisplayPostInstall(false);
          if (prevPath === "/backup") navigate("/backup", { replace: true });
          else if (prevPath === "/restore")
            navigate("/restore", { replace: true });
        });
    };
    const excludeProjects = async (token) => {
      const data = {
        excludedProject: excludedProjects,
        includedProject: includedProjects,
      };
      await API.post(`/api/exclude_projects`, data, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          initiateBackup(token);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
          setDisplayPostInstall(false);
          if (prevPath === "/backup") navigate("/backup", { replace: true });
          else if (prevPath === "/restore")
            navigate("/restore", { replace: true });
        });
    };
    const initiateBackup = async (token) => {
      await API.get(`/api/initiate_backup?backupType=0&install=1`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setDisplayPostInstall(false);
          if (prevPath === "/backup") navigate("/backup", { replace: true });
          else if (prevPath === "/restore")
            navigate("/restore", { replace: true });
        })
        .catch(function (error) {
          const data = errorHandler(error);
          setMainMessage({ appearance: "error", text: data.message });
          setDisplayPostInstall(false);
          if (prevPath === "/backup") navigate("/backup", { replace: true });
          else if (prevPath === "/restore")
            navigate("/restore", { replace: true });
        });
    };
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      pauseBackup(token);
      excludeProjects(token);
    });
  };

  return (
    <>
      {!next && !projectPage ? (
        <div className={styles.welcomeMainContainer}>
          <div className={styles.welcomeContainer}>
            <div className={styles.welcomeInfoContainer}>
              <img src={logo} alt="revyzlogo" className={styles.logo} />
              <div className={styles.title}>
                <strong>
                  Welcome to Revyz Backup & Restore for Jira Software
                </strong>
              </div>
              <div className={styles.subtitle}>
                <div
                  style={{
                    display: "flex",

                    alignItems: "center",
                  }}
                >
                  <CheckCircleOutlineIcon primaryColor="green" />
                  <span style={{ marginLeft: "0.5rem" }}>
                    &nbsp;Automated daily & on-demand backups of your Jira
                    Software Projects
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",

                    alignItems: "center",
                  }}
                >
                  <CheckCircleOutlineIcon primaryColor="green" />
                  <span style={{ marginLeft: "0.5rem" }}>
                    &nbsp;Granular restores of issues and configuration objects
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",

                    alignItems: "center",
                  }}
                >
                  <CheckCircleOutlineIcon primaryColor="green" />
                  <span style={{ marginLeft: "0.5rem" }}>
                    &nbsp;Secure offsite storage of encrypted backup data
                  </span>
                </div>
              </div>
              <div className={styles.getStarted}>
                <Button
                  appearance="primary"
                  onClick={() => {
                    setNext(true);
                    setWelcomePage(false);
                  }}
                >
                  Get started
                </Button>
              </div>
            </div>
          </div>
        </div>
      ) : next && !projectPage ? (
        <>
          <div className={styles.mainContainer}>
            <div className={styles.subContainer}>
              <ModalTransition>
                {showConfirmation && (
                  <Modal onClose={() => setShowConfirmation(false)}>
                    <ModalHeader>
                      <ModalTitle>Confirm Settings</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                      <div>Verify the selected settings before proceeding.</div>
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        appearance="subtle"
                        onClick={() => setShowConfirmation(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          handleFinish();
                          setShowConfirmation(false);
                        }}
                        appearance="primary"
                        autoFocus
                      >
                        Confirm
                      </Button>
                    </ModalFooter>
                  </Modal>
                )}
              </ModalTransition>
              <div className={styles.row}>
                <div className={styles.card}>
                  <div className={styles.iconcontainer}>
                    <LocationIcon size="xlarge" primaryColor="#0052cc" />
                  </div>
                  <div className={styles.cardName}>
                    <span className={styles.cardTitle}>
                      <strong>
                        Data storage region: US East (N. Virginia)
                      </strong>
                    </span>

                    <div
                      style={{
                        color: "grey",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                    >
                      <div>
                        We will be adding more data storage regions over the
                        course of time.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.card}>
                  <div className={styles.iconcontainer}>
                    <RecentIcon size="xlarge" primaryColor="#0052cc" />
                  </div>
                  <div className={styles.cardName}>
                    <span className={styles.cardTitle}>
                      <strong>Backup frequency: Every 24 hours</strong>
                    </span>
                    <div style={{ color: "grey" }}>
                      Additional frequency options coming soon, may require the
                      purchase of an add-on
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.card}>
                  <div className={styles.iconcontainer}>
                    <ArchiveIcon size="xlarge" primaryColor="#0052cc" />
                  </div>
                  <div className={styles.cardName}>
                    <span className={styles.cardTitle}>
                      <strong>Data retention period: 1 year</strong>
                    </span>
                    <div style={{ color: "grey" }}>
                      Additional retention period options coming soon, may
                      require the purchase of an add-on.
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.row}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <Button
                    appearance="primary"
                    onClick={() => {
                      setProjectPage(true);
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <ProjectExclusion
          handleFinish={handleFinish}
          setNext={setNext}
          setProjectPage={setProjectPage}
        />
      )}
    </>
  );
};

export default PostInstallPage;
